
import { Vue, Component, Watch } from 'vue-property-decorator'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import date from 'date-and-time'
import type { PreRaceT } from 'shared/types/erg'
import { ErgState, Erg } from 'shared/state'
import { PreRaceState } from 'shared/state'
import { formatTime } from 'shared/util'

@Component({ components: { ScaleLoader } })
export default class Wait extends Vue {
@PreRaceState() pre_race!: PreRaceT

get logbook_id() {
  const m = this.$route.path.match(/\d+/g)
  return m ? m[0] : ''
}

get timeHTML() {
  if(!this.pre_race) { return '' }
  let s = `Scheduled ${this.scheduledTime}`
  s += (this.pre_race.scheduled !== this.pre_race.projected)
   ? `${this.$t(', now starting at ')}<span style="color: lightgreen;font-weight:bold;text-shadow: 1px 1px gray;">${this.projectedTime}.</span>`
   : ``
  return s
}

get entered() {
  return !!this.pre_race?.entered?.find(e => e.logbook_id === this.logbook_id)
}

isActive(lb: string) {
  return (lb === this.logbook_id)
}

get registered() {
  if(!this.pre_race) { return [] }
  return this.pre_race.entered
}

get scheduledTime() {
  return this.pre_race && this.pre_race?.scheduled ? this.convertTime(this.pre_race.scheduled) : ''
}
get projectedTime() {
  return this.pre_race?.projected ? this.convertTime(this.pre_race.projected) : this.scheduledTime
}
get duration() {
  if((!this.pre_race || !(this.pre_race.duration || this.pre_race.duration_type))) { return ''}
  if(['time', 'time_max_distance', 'time_max_cals'].includes(this.pre_race.duration_type)) {
	return `${this.$t('Time')} ${this.$t('Race')} ${ formatTime(parseInt(this.pre_race.duration))}`
  }
  return `${this.$t(this.pre_race?.duration)} ${this.$t(this.pre_race?.duration_type)}`

}
get units() {
  if((!this.pre_race || !(this.pre_race.duration || this.pre_race.duration_type))) { return ''}
		if (this.pre_race.duration_type === 'meters') { return 'meters' }
		if (['time', 'time_max_distance', 'time_max_cals'].includes(this.pre_race.duration_type)) { return `${this.$t('seconds')}` }
		return `${this.$t('calories')}`
}

convertTime(gmt: string) {
  const d = date.parse(gmt, 'YYYY-M-D H:mm:ss', true)
  return date.format(d, 'h:mm A')
}


get backgroundStyle() {
  return  {
	background: this.$route.name.includes('camera') ? 'transparent' : 'white'
  }
}
}
